import React from 'react'
import { red } from 'lib/theme'

import { DiscountProps } from 'components/ProfilePage/type'

import styles from './DiscountStarBadge.module.css'

interface DiscountPercentageBadgeProps {
  discount: DiscountProps
  style?: React.CSSProperties
  backgroundColor?: string
  size?: number
}

const DiscountStarBadge: React.FC<DiscountPercentageBadgeProps> = ({
  discount,
  style: styleProps = {},
  backgroundColor = red,
  size = 40,
}) => {
  if (!discount || !discount.discountPercent) return null

  // Do not show discount percentage badge if the discount is lower than 10%
  if (discount.discountPercent <= 9) return null

  const style = {
    minWidth: size,
    minHeight: size,
    ...styleProps,
  }

  return (
    <div className={styles.discountPercentageBadge} style={style}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        className={styles.background}
        viewBox="0 0 24 24"
      >
        <path
          fill={backgroundColor}
          d="M12 0l2.139 2.629 3.068-1.441.786 3.297 3.389.033-.722 3.312 3.039 1.5-2.088 2.67 2.088 2.67-3.039 1.5.722 3.312-3.389.033-.786 3.297-3.068-1.441-2.139 2.629-2.139-2.629-3.068 1.441-.786-3.297-3.389-.033.722-3.312-3.039-1.5 2.088-2.67-2.088-2.67 3.039-1.5-.722-3.312 3.389-.033.786-3.297 3.068 1.441z"
        />
      </svg>
      <div className={styles.text}>{-discount.discountPercent}%</div>
    </div>
  )
}

export default DiscountStarBadge
